import YearRange from './src/index'

YearRange.install = function (Vue) {
  Vue.component(YearRange.name, YearRange)
}

export default YearRange
